import {
    API
} from '../Api.class';
import {
    InventoryStatsAPI
} from './InventoryStats.api';
import {
    InventoryTypesAPI
} from './InventoryType.api';

export class InventoryAPI extends API {

    constructor(baseUrl) {
        super(baseUrl)

        this.Types = new InventoryTypesAPI(baseUrl);
        this.Stats = new InventoryStatsAPI(baseUrl);

    }


    async list(pagination, filter, meta) {
        this.loading = true

        return await this.__axiosInstance.get('api/v1/inventory', {
            meta,
            params: {
                ...pagination,
                ...filter
            }
        })
    }

    async get(id, meta) {
        this.loading = true

        return await this.__axiosInstance.get(`api/v1/inventory/${id}`, {
            meta
        });

    }

    async create(body, meta) {
        this.loading = true;

        return await this.__axiosInstance.post('api/v1/inventory', body, {
            meta
        });
    }
    async update(creative, meta) {
        this.loading = true

        return await this.__axiosInstance.put(`api/v1/inventory/${creative.id}`, creative, {
            meta
        });
    }

    async delete(creative, meta) {
        this.loading = true

        return await this.__axiosInstance.delete(`api/v1/inventory/${creative.id}`, {
            meta
        });
    }
}